import React from 'react'

const TicketsLayout = () => {
  return (
    <div>
      <h1>TicketsLayout</h1>
    </div>
  )
}

export default TicketsLayout
